"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CheckoutImage = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _constants = require("./constants");
var _useCheckoutImage = require("./useCheckoutImage");
var _jsxRuntime = require("react/jsx-runtime");
const CheckoutImageRoot = (0, _mui.styled)(_components.LazyImage)(({
  ownerState,
  theme
}) => ({
  display: 'inline-grid',
  justifyItems: 'center',
  alignItems: 'center',
  backgroundColor: ownerState.background,
  color: theme.palette.grey[300],
  opacity: ownerState.opacity,
  fontSize: `${ownerState.fontSize.sm}rem`,
  height: ownerState.ignoreContainerSize ? ownerState.size.sm : ownerState.height,
  width: ownerState.ignoreContainerSize ? ownerState.size.sm : ownerState.width,
  [`& .${_components.lazyImageClasses.image}`]: {
    maxHeight: ownerState.size.sm,
    maxWidth: ownerState.size.sm
  },
  ...(!ownerState.isBasketItemSmall && {
    [theme.breakpoints.up('md')]: {
      fontSize: `${ownerState.fontSize.md}rem`,
      height: ownerState.ignoreContainerSize ? ownerState.size.md : ownerState.height,
      width: ownerState.ignoreContainerSize ? ownerState.size.md : ownerState.width,
      [`& .${_components.lazyImageClasses.image}`]: {
        maxHeight: ownerState.size.md,
        maxWidth: ownerState.size.md
      }
    }
  })
}));
const NoImageRoot = (0, _mui.styled)('span')(({
  ownerState,
  theme
}) => ({
  display: 'inline-grid',
  justifyItems: 'center',
  alignItems: 'center',
  backgroundColor: ownerState.background,
  color: theme.palette.grey[300],
  opacity: ownerState.opacity,
  fontSize: `${ownerState.fontSize.sm}rem`,
  height: ownerState.ignoreContainerSize ? ownerState.size.sm : ownerState.height,
  width: ownerState.ignoreContainerSize ? ownerState.size.sm : ownerState.width,
  ...(!ownerState.isBasketItemSmall && {
    [theme.breakpoints.up('md')]: {
      fontSize: `${ownerState.fontSize.md}rem`,
      height: ownerState.ignoreContainerSize ? ownerState.size.md : ownerState.height,
      width: ownerState.ignoreContainerSize ? ownerState.size.md : ownerState.width
    }
  })
}));
const SkeletonRoot = (0, _mui.styled)(_mui.Skeleton)(({
  ownerState,
  theme
}) => ({
  height: ownerState.ignoreContainerSize ? ownerState.size.sm : ownerState.height,
  width: ownerState.ignoreContainerSize ? ownerState.size.sm : ownerState.width,
  ...(!ownerState.isBasketItemSmall && {
    [theme.breakpoints.up('md')]: {
      height: ownerState.ignoreContainerSize ? ownerState.size.md : ownerState.height,
      width: ownerState.ignoreContainerSize ? ownerState.size.md : ownerState.width
    }
  })
}));
const CheckoutImage = exports.CheckoutImage = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _mui.useThemeProps)({
    props: inProps,
    name: 'CheckoutImage'
  });
  const {
    alt,
    testId,
    component = _constants.COMPONENT,
    loading = _constants.LOADING,
    src,
    size = _constants.SIZE,
    background = _constants.BACKGROUND,
    opacity = _constants.OPACITY,
    width = _constants.WIDTH,
    height = _constants.HEIGHT,
    ...otherProps
  } = props;
  const {
    imageSrc,
    sizeValue,
    backgroundColor,
    fontSizeValue
  } = (0, _useCheckoutImage.useCheckoutImage)({
    src,
    size,
    background
  });
  const ownerState = {
    size: sizeValue,
    background: backgroundColor,
    opacity,
    fontSize: fontSizeValue,
    width,
    height,
    ignoreContainerSize: size === 'basketItem' || size === 'basketItemSmall',
    isBasketItemSmall: size === 'basketItemSmall'
  };
  const testIdValue = testId ? imageSrc === 'missing' ? `${testId}-missing` : testId : undefined;
  const fallbackComponent = /*#__PURE__*/(0, _jsxRuntime.jsx)(SkeletonRoot, {
    variant: "rectangular",
    animation: "wave",
    ownerState: ownerState
  });
  if (imageSrc === 'missing') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(NoImageRoot, {
      as: component,
      ownerState: ownerState,
      "data-testid": testIdValue,
      ...otherProps,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Products, {
        fontSize: "inherit"
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(CheckoutImageRoot, {
    component: component,
    loading: loading,
    ownerState: ownerState,
    src: decodeURI(imageSrc),
    alt: alt,
    "data-testid": testIdValue,
    errorFallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Products, {
      fontSize: "inherit"
    }),
    fallback: fallbackComponent,
    ...otherProps
  });
});
var _default = exports.default = CheckoutImage;
